<template>
    <!-- 编辑分组信息 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item  prop="group_name" >
          <template slot="label">
            <span class="required">*</span>
            <span>分组名称</span>
          </template>
          <v-input type="text" name="group_name" v-model="ruleForm.group_name"></v-input>
        </v-form-item>
        <!-- <v-form-item  prop="group_sort" >
          <template slot="label">
            <span class="required">*</span>
            <span>分组排序</span>
          </template>
          <v-input type="text" name="group_sort" v-model="ruleForm.group_sort"></v-input>
        </v-form-item> -->
        <v-form-item  prop="group_desc" >
          <template slot="label">
            <span class="required">*</span>
            <span>描述</span>
          </template>
          <v-input type="textarea" class="remarks" name="group_desc" :maxlength="200" v-model="ruleForm.group_desc" show-word-limit></v-input>
        </v-form-item>

        </v-form>
      </v-dialog>

    </div>

</template>

  <script>
import { copy } from '@/common/libs/utils';

  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      infoData:{
        type:Object,
        default: ()=>{}
      }
    },
    data() {
      return {
        dialogTitle: "编辑分组信息",
        rules: {
          group_name: copy([{
            type: "nameInput",
            args: [1,32]
          }]),
        },
        ruleForm:{
          group_name: '',
          group_desc: '',
          appid: '',
          // group_sort: '',
          id: '',
        },
        isShow:false,
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){
        this.ruleForm = copy(this.infoData)
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        let submitData = { ...this.ruleForm };
        // submitData.group_sort = Number(submitData.group_sort)
        this.$put("/td/td-iot-api/iot/group/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
